import {
  ROLE_SYSTEM_ADMIN,
  ROLE_QA_MANAGER,
  ROLE_PROJECT_MNG,
} from '@/utils/const';

export default [{
  path: '/settings/general_configuration',
  name: 'generalConfiguration',
  component: () => import('@/views/settings/generalConfiguration/index.vue'),
  meta: {
    title: 'General configuration',
    middleware: {
      access: 'auth',
      rules: [
        ROLE_SYSTEM_ADMIN,
      ],
    },
  },
},
{
  path: '/settings/formatting',
  name: 'formatting',
  component: () => import('@/views/settings/generalConfiguration/formatting/index.vue'),
  meta: {
    title: 'Formatting',
    middleware: {
      access: 'auth',
      rules: [
        ROLE_SYSTEM_ADMIN,
      ],
    },
  },
},
{
  path: '/settings/logo',
  name: 'editLogo',
  component: () => import('@/views/settings/generalConfiguration/Logo/index.vue'),
  meta: {
    title: 'LogoEdit',
    middleware: {
      access: 'auth',
      rules: [
        ROLE_SYSTEM_ADMIN,
      ],
    },
  },
},
{
  path: '/settings/notifications',
  name: 'notifications',
  component: () => import('@/views/settings/generalConfiguration/notifications/index.vue'),
  meta: {
    title: 'Notifications',
    middleware: {
      access: 'auth',
      rules: [
        ROLE_SYSTEM_ADMIN,
        ROLE_QA_MANAGER,
        ROLE_PROJECT_MNG,
      ],
    },
  },
},
{
  path: '/settings/accountTypes',
  name: 'accountTypes',
  component: () => import('@/views/settings/generalConfiguration/accountTypes/index.vue'),
  meta: {
    title: 'Account types',
    middleware: {
      access: 'auth',
      rules: [
        ROLE_SYSTEM_ADMIN,
      ],
    },
  },
},
{
  path: '/settings/accountTypes/edit/:id?',
  name: 'accountTypeEdit',
  component: () => import('@/views/settings/generalConfiguration/accountTypes/edit/index.vue'),
  meta: {
    title: 'Account types',
    middleware: {
      access: 'auth',
      rules: [
        ROLE_SYSTEM_ADMIN,
      ],
    },
  },
},
{
  path: '/settings/user_administration',
  name: 'userAdministration',
  component: () => import('@/views/settings/generalConfiguration/userAdministration/index.vue'),
  meta: {
    title: 'User administration',
    middleware: {
      access: 'auth',
      rules: [
        ROLE_SYSTEM_ADMIN,
      ],
    },
  },
},
{
  path: '/settings/data_configurations',
  name: 'dataConfigurations',
  component: () => import('@/views/settings/dataConfiguration/index.vue'),
  meta: {
    title: 'Data configurations',
    middleware: {
      access: 'auth',
      rules: [
        ROLE_SYSTEM_ADMIN,
      ],
    },
  },
},
{
  path: '/settings/evaluation_methods',
  name: 'evaluationMethods',
  component: () => import('@/views/settings/dataConfiguration/evaluationMethods/index.vue'),
  meta: {
    title: 'Evaluation methods',
    middleware: {
      access: 'auth',
      rules: [
        ROLE_SYSTEM_ADMIN,
      ],
    },
  },
},
{
  path: '/settings/error_configuration',
  name: 'errorConfiguration',
  component: () => import('@/views/settings/dataConfiguration/errorConfiguration/index.vue'),
  meta: {
    title: 'Error configuration',
    middleware: {
      access: 'auth',
      rules: [
        ROLE_SYSTEM_ADMIN,
      ],
    },
  },
},
{
  path: '/settings/error_configuration/:id',
  name: 'errorConfiguration.history',
  component: () => import('@/views/settings/dataConfiguration/errorConfiguration/history/index.vue'),
  meta: {
    title: 'Error configuration',
    middleware: {
      access: 'auth',
      rules: [
        ROLE_SYSTEM_ADMIN,
      ],
    },
  },
},
{
  path: '/settings/metarules',
  name: 'metarules',
  component: () => import('@/views/settings/dataConfiguration/metaRules/index.vue'),
  meta: {
    title: 'Metarules',
    middleware: {
      access: 'auth',
      rules: [
        ROLE_SYSTEM_ADMIN,
      ],
    },
  },
},
{
  path: '/settings/metrics',
  name: 'metrics',
  component: () => import('@/views/settings/dataConfiguration/metrics/index.vue'),
  meta: {
    title: 'Metrics',
    middleware: {
      access: 'auth',
      rules: [
        ROLE_SYSTEM_ADMIN,
      ],
    },
  },
},
{
  path: '/settings/metrics/create',
  name: 'metrics.create',
  component: () => import('@/views/settings/dataConfiguration/metrics/edit/index.vue'),
  meta: {
    title: 'Metrics',
    middleware: {
      access: 'auth',
      rules: [
        ROLE_SYSTEM_ADMIN,
      ],
    },
  },
},
{
  path: '/settings/metrics/edit/:id',
  name: 'metrics.edit',
  component: () => import('@/views/settings/dataConfiguration/metrics/edit/index.vue'),
  meta: {
    title: 'Metrics',
    middleware: {
      access: 'auth',
      rules: [
        ROLE_SYSTEM_ADMIN,
      ],
    },
  },
},
{
  path: '/settings/languages_cinfiguration',
  name: 'languagesConfiguration',
  component: () => import('@/views/settings/dataConfiguration/languagesConfiguration/index.vue'),
  meta: {
    title: 'Languages cinfiguration',
    middleware: {
      access: 'auth',
      rules: [
        ROLE_SYSTEM_ADMIN,
      ],
    },
  },
},
{
  path: '/settings/workflow_configuration',
  name: 'workflowConfiguration',
  component: () => import('@/views/settings/workflowsConfiguration/index.vue'),
  meta: {
    title: 'Workflow configuration',
    middleware: {
      access: 'auth',
      rules: [
        ROLE_SYSTEM_ADMIN,
      ],
    },
  },
},
{
  path: '/settings/worlflow_steps',
  name: 'worlflowSteps',
  component: () => import('@/views/settings/workflowsConfiguration/steps/index.vue'),
  meta: {
    title: 'Worlflow steps',
    middleware: {
      access: 'auth',
      rules: [
        ROLE_SYSTEM_ADMIN,
      ],
    },
  },
},
{
  path: '/settings/workflow_documents',
  name: 'workflowDocuments',
  component: () => import('@/views/settings/workflowsConfiguration/documents/index.vue'),
  meta: {
    title: 'Workflow documents',
    middleware: {
      access: 'auth',
      rules: [
        ROLE_SYSTEM_ADMIN,
      ],
    },
  },
},
{
  path: '/settings/industry_classification',
  name: 'IndustrySectorsSettings',
  component: () => import('@/views/settings/myproofConfiguration/industryClassification/index.vue'),
  meta: {
    title: 'Workflow documents',
    middleware: {
      access: 'auth',
      rules: [
        ROLE_SYSTEM_ADMIN,
      ],
    },
  },
},
];
